import rightBig from "../assets/images/rightBig.png";
import leftBig from "../assets/images/left_big.png";

function Hero() {
  return (
    <section
      id="hero"
      className="flex justify-center items-center flex-col gap-4 max-sm:gap-8 text-center z-1 py-[8%] pt-[14%] max-lg:py-[20%] relative overflow-hidden bg-yellow max-sm:pt-[40%]"
    >
      <img
        src={leftBig}
        alt="bg"
        className="absolute circle-reverse top-[-15%]   lg:left-[-25%] left-[-15%]  max-sm:w-[400px] opacity-[.5] max-lg:w-[300px]"
      />
      <img
        src={rightBig}
        alt="bg"
        className="circle absolute bottom-0 right-[-15%] max-md:right-[-10%] lg:right-[-25%] opacity-[.5] max-sm:w-[300px] max-lg:w-[300px] max-sm:bottom-[-10%]"
      />

      <h1 className=" outlined-text-mini  text-[50px] max-lg:text-[40px] text-transparent max-sm:text-[30px]">
        <span className="animation-2">Hello there</span>
        <br />
        <span className="text-[100px]  overflow-hidden max-lg:text-[80px] max-sm:text-[44px] text-transparent animation-2">
          I’m
          <span className="text-black ">KARIM</span>
        </span>
        <br />
        <span className="animation-2">Full Stack Developer</span>
      </h1>
      <p className="lg:w-[40%] max-lg:w-[50%] max-sm:w-[90%] my-4 mb-6 animation-2">
        I'm a passionate full-stack web developer with a strong foundation in
        both front-end and back-end technologies. I thrive on crafting dynamic,
        user-centric web applications that not only look great but also perform
        flawlessly
      </p>
      <button className="bg-black p-3 w-[30%] max-sm:w-[90%] text-white rounded-md ">
        Let's collaborate!
      </button>
    </section>
  );
}

export default Hero;
